import SecureIcon from '@/assets/icons/secure-primary.svg';
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import RegisterV2Layout from '../../components/register-form-v2/layout';
import VerifyCodeV2 from '../../components/register-form-v2/verify-code';
import { useCallback } from 'react';
import { ICustomerVerifyCodeResponse } from '@/shared/endpoints/customers';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import { useCookies } from 'react-cookie';
import { GtmEvent } from '@/shared/types/enums';
import { usePostHog } from '@/shared/hooks/usePostHog'


const ConfirmCodePage = () => {
    const sendDataToGTM = useGTMDispatch();
    const posthog = usePostHog();
    const [, setCookie] = useCookies(['sessionRecording']);
    const { state } = useLocation();
    const email = (state.email || '').replace(/\s/g, '+');
    const initialSourceForDelivery = state.otpDeliverySource || '';
    const initialOtpTarget = state.otpTarget === 'EMAIL' ? 'email' : 'phone';
    const terms = state.terms;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const handleConfirmCode = useCallback(
        (payload: ICustomerVerifyCodeResponse) => {
            const { id } = payload;
            sendDataToGTM({ event: GtmEvent.LOGIN, userId: id, sessionRecording: terms });
            posthog?.capture(GtmEvent.LOGIN);
            setCookie('sessionRecording', terms, { path: "/" });
        },
        [sendDataToGTM, setCookie, terms]
    );

    const additionalProps = isMobile ? { alignItems: 'items-center' } : {};
    return (
        <div data-testid="confirm-code-container" className="flex w-full flex-auto items-start justify-center bg-[#f8f5f0]">
            <RegisterV2Layout icon={SecureIcon} subTitle="Secure Verification Required" {...additionalProps}>
                <VerifyCodeV2
                    initialSourceForDelivery={initialSourceForDelivery}
                    email={email}
                    onSubmit={handleConfirmCode}
                    initialSignUpOtpTarget={initialOtpTarget}
                />
            </RegisterV2Layout>
        </div>
    );
};

export default ConfirmCodePage;
